import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { EListDetailsStatus} from '../../../../constants';
import { listDetailsStatusActionSet } from '../../../../store/actions/listDetailsStatusActionSet';
import { listSetName } from '../../../../../../../../rest/effects/list/listSetName';
import { TListId } from '../../../../../../../../types/types';

export const saveListName = (
    listId: TListId,
    name: string
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(listDetailsStatusActionSet(EListDetailsStatus.saving));
        dispatch(listSetName(listId, name))
            .then(() => {
                dispatch(listDetailsStatusActionSet(EListDetailsStatus.saved))
            })
    };
    return action;
};
